import React, { useState } from 'react';
import { ColorList } from './ColorList';

const ColorPicker = ({
  setRestColorCodes,
  restColorCodes,
  num,
  posLeft,
  posBottom,
  colorChoice,
}) => {
  const [showColorList, setShowColorList] = useState(null);

  const handleSelectColor = (color, key) => {
    setRestColorCodes(prev => ({ ...(prev || {}), [key]: color }));
    setShowColorList(null);
  };

  const colorValue = restColorCodes?.[colorChoice] ?? '#e0e0e0';

  return (
    <div className="color-picker">
      <button
        style={{
          backgroundColor: colorValue,
          background: colorValue,
          position: 'absolute',
          left: posLeft,
          bottom: posBottom,
        }}
        className="color-picker-button"
        onClick={() => setShowColorList(prev => (prev === colorChoice ? null : colorChoice))}
      >
        {num}
        {showColorList === colorChoice && (
          <div
            className="color-list"
            style={{
              ...(num === 9 || num === 3 || num === 12 || num === 6
                ? { right: '30px' }
                : { left: '30px' }),
              ...(num === 1 || num === 4 || num === 5 || num === 2 || num === 3 || num === 6
                ? { top: 'auto', bottom: '100%' }
                : { top: '100%', bottom: 'auto' }),
            }}
          >
            <ColorList
              onSelectColor={color => handleSelectColor(color, colorChoice)}
              setShowColorList={setShowColorList}
            />
          </div>
        )}
      </button>
    </div>
  );
};

export default ColorPicker;
